function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
} // Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi


var hasPassiveEvents = false;

if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }

  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0; // returns true if `el` should be allowed to receive touchmove events.

var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event; // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.

  if (allowTouchMove(e.target)) {
    return true;
  } // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).


  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;

    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  } // If previousBodyOverflowSetting is already set, don't set it again.


  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight; // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.

    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting; // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.

    previousBodyOverflowSetting = undefined;
  }
}; // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions


var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  } // disableBodyScroll must not have been called on this targetElement before


  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };
  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };

    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};
var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class OptionsStore {
  /*
   * @param {Object} options
   */
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _defineProperty(this, "options", void 0);

    this.options = options;
  } // eslint-disable-next-line no-unused-vars,class-methods-use-this


  getData() {
    throw new Error('Please utilize a proper existing store or implement your own.');
  } // eslint-disable-next-line class-methods-use-this,no-unused-vars


  setData(data) {
    throw new Error('Please utilize a proper existing store or implement your own.');
  } // eslint-disable-next-line no-unused-vars,class-methods-use-this


  removeData() {
    throw new Error('Please utilize a proper existing store or implement your own.');
  }

}

/*! js-cookie v3.0.1 | MIT */

/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      target[key] = source[key];
    }
  }

  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */


var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }

    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function (value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }

    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';

    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue;
      } // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...


      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }

  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    } // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.


    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};

    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar;
  }

  return Object.create({
    set: set,
    get: get,
    remove: function (key, attributes) {
      set(key, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function (attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function (converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}

var api = init(defaultConverter, {
  path: '/'
});

class CookieOptionsStore extends OptionsStore {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    const defaultOptions = {
      cookieName: '_cookie-consent',
      attributes: {
        // https://github.com/js-cookie/js-cookie#cookie-attributes
        expires: 365,
        sameSite: 'Strict'
      }
    };
    this.options = { ...defaultOptions,
      ...options
    };
  }

  getData() {
    const data = api.get(this.options.cookieName);

    if (data === undefined) {
      return null;
    }

    return JSON.parse(data);
  } // eslint-disable-next-line class-methods-use-this


  setData(data) {
    api.set(this.options.cookieName, JSON.stringify(data), this.options.attributes);
  }

  removeData() {
    api.remove(this.options.cookieName);
  }

}

/**
 * Ask user for cookie consent. We use template elements as placeholders for cookie sensitive scripts.
 * The content of these template elements will be loaded if the visitor has given cookie consent.
 */

class CookieConsent {
  /**
   * @param {HTMLElement} dialog
   * @param {Object} options
   * @param {OptionsStore} store
   */
  constructor(dialog) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new CookieOptionsStore();
    this.dialog = dialog;
    this.store = store;
    const defaultOptions = {
      templateSelector: '[data-consent-loading=""]',
      templateCategorySelector: '[data-consent-loading={0}]',
      templateTypeSelector: '[data-consent-type={0}]',
      optionsToggleSelector: '.cookie-consent__options-toggle',
      optionsSectionSelector: '.cookie-consent__options',
      optionsButtonsSelector: '.cookie-consent__buttons.-options',
      generalButtonsSelector: '.cookie-consent__buttons.-general',
      triggerPopupSelector: '.js-change-cookie-consent',
      hideHelperClass: 'h-hidden',
      agreeValue: 'yes',
      disagreeValue: 'no',
      saveOptionsValue: 'save_options',
      categoriesFieldName: 'categories',
      hideDialog: false,
      useDefaultConsentHandling: true,
      version: '1'
    };
    this.options = { ...defaultOptions,
      ...options,
      ...this.dialog.dataset
    };
    this.init();
  }
  /**
   * Get answer and handle accordingly
   * Optionally consent handling can be customized
   */


  init() {
    const answerData = this.getSavedAnswer();

    if (!answerData) {
      this.disableDialogForDialogLinks();
    }

    if (this.options.useDefaultConsentHandling) {
      this.attachDialogListeners();
      this.attachIframeTemplateListeners();
      this.attachTriggerPopupLinkListeners();

      if (!this.options.hideDialog && !answerData) {
        this.showDialog();
      }
    }

    if (answerData && answerData.consent === this.options.agreeValue) {
      this.renderTemplates(answerData.categories);
    }
  }
  /**
   * Set listener to watch answer
   */


  attachDialogListeners() {
    this.dialog.addEventListener('close', () => {
      enableBodyScroll(this.dialog); // Stop if no answer is given

      if (this.dialog.returnValue.length === 0) {
        return;
      }

      let data = {
        version: this.options.version,
        consent: this.dialog.returnValue
      };

      if (data.consent !== this.options.disagreeValue) {
        data.categories = [];
        let categoryFields = [];

        if (data.consent === this.options.saveOptionsValue) {
          categoryFields = this.dialog.querySelectorAll('input[name="' + this.options.categoriesFieldName + '[]"]:checked');
          data.consent = this.options.agreeValue;
        } else if (data.consent === this.options.agreeValue) {
          categoryFields = this.dialog.querySelectorAll('input[name="' + this.options.categoriesFieldName + '[]"]');
        }

        categoryFields.forEach(categoryField => {
          data.categories.push(categoryField.value);
        });

        try {
          this.renderTemplates(data.categories);
        } catch (e) {// In some rare conditions (IE) this can throw an error and then the answer can't be saved
        }
      }

      this.saveAnswer(data);
    });
    this.optionsToggle = this.dialog.querySelector(this.options.optionsToggleSelector);
    this.optionsSection = this.dialog.querySelector(this.options.optionsSectionSelector);
    this.optionsButtons = this.dialog.querySelector(this.options.optionsButtonsSelector);
    this.generalButtons = this.dialog.querySelector(this.options.generalButtonsSelector);

    if (this.optionsToggle && this.optionsSection) {
      this.optionsToggle.addEventListener('click', e => {
        e.preventDefault();
        this.toggleOptions();
      });
    }
  }
  /**
   * Clicking on inactive iframes will prompt the cookie dialog
   */


  attachIframeTemplateListeners() {
    document.querySelectorAll(this.options.templateTypeSelector.replace('{0}', 'iframe')).forEach(template => {
      template.classList.add('-has-iframe');
      template.addEventListener('click', e => {
        this.showDialog();
      });
    });
  }
  /**
   * Allow to open the dialog via links that you can set in the cookie policy for example
   */


  attachTriggerPopupLinkListeners() {
    document.querySelectorAll(this.options.triggerPopupSelector).forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        this.showDialog();
        this.toggleOptions(true);
      });
    });
  }
  /**
   * Get saved cookie consent
   *
   * @return {Object|null}
   */


  getSavedAnswer() {
    try {
      const data = this.store.getData();

      if (data === null) {
        return null;
      }

      if (data.version === this.options.version) {
        if (typeof data.categories !== 'object') {
          data.categories = []; // Makes it handy for later use
        }

        return data;
      }
    } catch (e) {
      /* Invalid cookie */
    }

    this.store.removeData();
    return null;
  }
  /**
   * Save consent in a cookie
   * Per answer you can set custom cookie attributes
   *
   * @param {Object} data
   */


  saveAnswer(data) {
    this.store.setData(data);
    this.dialog.dispatchEvent(new CustomEvent('answer', {
      detail: data
    }));
  }
  /**
   * Replace the template elements with its content
   *
   * @param {Array} categories
   */


  renderTemplates(categories) {
    // Render templates that hold scripts that use structural cookies
    document.querySelectorAll(this.options.templateSelector).forEach(template => template.parentElement.replaceChild(template.content, template)); // Render templates that hold scripts that use a special category of cookies

    if (typeof categories === 'object') {
      categories.forEach(category => {
        document.querySelectorAll(this.options.templateCategorySelector.replace('{0}', category)).forEach(template => template.parentElement.replaceChild(template.content, template));
        this.dialog.dispatchEvent(new CustomEvent('activateCategory', {
          detail: {
            category: category
          }
        }));
      });
    }
  }
  /**
   * Show dialog and disable scroll
   */


  showDialog() {
    this.loadAnswerCategories();
    this.dialog.showModal();
    disableBodyScroll(this.dialog);
    this.dialog.dispatchEvent(new Event('open'));
  }
  /**
   * Hide dialog for all links used in the dialog like cookie policy
   */


  disableDialogForDialogLinks() {
    this.dialog.querySelectorAll('a').forEach(link => {
      if (window.location.href.indexOf(link.href) > -1) {
        this.options.hideDialog = true;
      }
    });
  }
  /**
   * Toggle options
   *
   * @param {boolean} [open]
   */


  toggleOptions(open) {
    if (this.optionsToggle && this.optionsSection) {
      if (open === true) {
        this.optionsSection.classList.remove(this.options.hideHelperClass);
        this.optionsButtons.classList.remove(this.options.hideHelperClass);
        this.generalButtons.classList.add(this.options.hideHelperClass);
      } else if (open === false) {
        this.optionsSection.classList.add(this.options.hideHelperClass);
        this.optionsButtons.classList.add(this.options.hideHelperClass);
        this.generalButtons.classList.remove(this.options.hideHelperClass);
      } else {
        this.optionsSection.classList.toggle(this.options.hideHelperClass);
        this.optionsButtons.classList.toggle(this.options.hideHelperClass);
        this.generalButtons.classList.toggle(this.options.hideHelperClass);
        open = !this.optionsSection.classList.contains(this.options.hideHelperClass);
      }

      this.dialog.dispatchEvent(new CustomEvent('toggleOptions', {
        detail: {
          open: open
        }
      }));
    }
  }

  loadAnswerCategories() {
    const answerData = this.getSavedAnswer();

    if (answerData) {
      const categoryFields = this.dialog.querySelectorAll('input[name="' + this.options.categoriesFieldName + '[]"]');
      categoryFields.forEach(categoryField => {
        categoryField.checked = answerData.categories.includes(categoryField.value);
      });
    }
  }

}

export { CookieConsent as default };
